import { registerLookup } from "@redriver/cinnamon";
import * as actions from "./actions";

export const clientAuthStatusLookup = registerLookup(
  "clientAuthStatusLookup",
  actions.clientAuthStatusLookup,
);
